package com.yogaaicoach.common.core.extensions

import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.number
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

/**
 * Short date: DD + MMM(short)
 */
fun LocalDate.formatDate(): String {
    val monthName = getShortMonthName(this.month.number)
    return "$monthName ${this.day}"
}

/**
 * Short date: DD + MMM(full month name)
 */
fun LocalDate.formatDateLong(): String {
    return "${this.day} ${monthName(this)} "
}

private fun monthName(date: LocalDate) =
    date.month.name.lowercase()
        .replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }

// TODO maybe these should come from string file, because in different language can be different
private fun getShortMonthName(month: Int): String {
    return when (month) {
        1 -> "Jan"
        2 -> "Feb"
        3 -> "Mar"
        4 -> "Apr"
        5 -> "May"
        6 -> "Jun"
        7 -> "Jul"
        8 -> "Aug"
        9 -> "Sep"
        10 -> "Oct"
        11 -> "Nov"
        12 -> "Dec"
        else -> ""
    }
}

@OptIn(ExperimentalTime::class)
fun LocalDate.weeksSinceNow(): Int {
    val today = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date
    return this.weeksSince(today)
}

fun LocalDate.weeksSince(dateEnd: LocalDate): Int {
    // Convert dates to days since epoch so we can subtract
    val daysPassed = dateEnd.toEpochDays() - this.toEpochDays()
    // +1 so that week 1 starts on the same day (day 0 = week 1, day 7 = week 2, etc.)
    // coerced to minimum 1 in case dateEnd is before this date
    return maxOf(1, daysPassed.floorDiv(7).toInt() + 1)
}
